import React, {useEffect, useMemo, useState} from 'react';
import { Form, Input, DatePicker,Select, Tag, Alert } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import request from 'request';
import {API_VEHICLE_LIST} from "../../../../../../hooks/carRental/_";
import {decryptTextByAES, encryptTextByAES} from "../../../../../../utils/encryption";
import MyModelCascader from "../../../../../product-price/base/vehicle-cascader-model";
import { formatTimeRange } from "../../../../../../utils/tool";

import moment from 'moment';
import EnumKeyToText from "../../../../../product-price/base/EnumKeyToText";
import {useOrderList} from "../../../../../../hooks/order-management/order-list";
import {_APIS} from "../../../../../../apis";


interface IComponentProps {
    data?: any;
    enums?: any
}
const CarPlatoon: React.FC<IComponentProps> = (props) => {
    const data = props.data;
    const { enums } = props
    const [list, setList] = useState<any>([]);
    const [modelInfo, setModelInfo] = useState<any>(null);

    const { getCarModelDetail } = useOrderList()

    const form = Form.useFormInstance();
    const changeType = (e: any) => {
        if (e) {
            const params =  {
                vehicle_id: e,
                veh_num_type: -1,
                status: 0,
                page: 1,
                page_size: 1000,
                store_code: data?.pickup_info?.store_code,
                order_code: data?.order_code

            }
            getCarModelDetail({
                vehicle_model_id: e
            }).then((res) => {
                setModelInfo(res.data || null)
            })
            request({
                url: _APIS.ORDER_MANAGEMENT.ORDER_LIST.GET_VEH_LIST_BY_ORDER_ID,
                method: 'GET',
                params,
            }).then(res => {
                const list = (res?.data?.list || []).map((item: any) => {

                    return {
                        value: item.veh_code,
                        label: (
                            <div>
                                <span>{decryptTextByAES(item.encrypt_veh_plate) }</span>
                                <Tag color={ item.occupied ? 'error' : 'success' } style={{marginLeft: 10}}>{ item.occupied ? '无库存' : '可更换'}</Tag>
                            </div>
                        ),
                        disabled: item.occupied, // 是否被占用（控制是否可选）
                    }
                })
                setList(list);
                form.setFieldsValue({
                    veh_code: ''
                })
            })
        } else {
            setList([])
            form.setFieldsValue({
                veh_code: ''
            })
        }
    }

    const defaultValueModel = useMemo(() => {
        return [
            data?.veh_model_info?.brand_name,
            data?.veh_model_info?.series_name,
            data?.veh_model_info?.model_name,
        ];
    }, [data])

    useEffect(() => {
        const params =  {
            vehicle_id: data?.veh_model_info?.model_id,
            veh_num_type: -1,
            status: 0,
            page: 1,
            page_size: 1000,
            store_code: data?.pickup_info?.store_code,
            order_code: data?.order_code
        }

        request({
            url: _APIS.ORDER_MANAGEMENT.ORDER_LIST.GET_VEH_LIST_BY_ORDER_ID,
            method: 'GET',
            params,
        }).then(res => {
            const list = (res?.data?.list || []).map((item: any) => {
                return {
                    value: item.veh_code,
                    label: (
                        <div>
                            <span>{decryptTextByAES(item.encrypt_veh_plate) }</span>
                            <Tag color={ item.occupied ? 'error' : 'success' } style={{marginLeft: 10}}>{ item.occupied ? '无库存' : '可更换'}</Tag>
                        </div>
                    ),
                    disabled: item.occupied, // 是否被占用（控制是否可选）
                }
            })
            setList(list);
        })
        form.setFieldsValue({
            chexing: data?.veh_model_info?.model_id,
            veh_code: data?.veh_info?.veh_code,
        })
        setModelInfo(data?.veh_model_info)
    }, []);

    const optionStyle = {display: 'flex', alignItems: 'center', justifyContent: 'space-between'};

    return (
        <>
            <Form.Item label={'订单编号'}>
                {data.order_code}
            </Form.Item>
            <Form.Item label={data.sourceType && data.sourceType == 'SPOccupyCalendar' ? '占库时间': '取还时间'}>
                {`${formatTimeRange(data?.pickup_info?.time, data?.return_info?.time)}`}
            </Form.Item>
            <Form.Item name={'chexing'} label={'预定车型'} rules={[{required: true, message: '请选择预定车型'}]}>
                <MyModelCascader storeCode={data?.pickup_info?.store_code}  defaultValue={defaultValueModel} onChange={changeType}></MyModelCascader>
                {
                    modelInfo && <div style={{marginTop: '10px'}} >
                        {modelInfo.group_code}
                        ｜ <EnumKeyToText data={modelInfo} enums={enums} valueKey={'transmission_type'}
                                         nameSpace={'transmission_type'}/>
                        ｜ <EnumKeyToText data={modelInfo} enums={enums} valueKey={'fuel_type'}
                                         nameSpace={'fule_type'}/>
                        ｜ {modelInfo.passenger_no}座
                        ｜ {modelInfo.door_no}门
                    </div>
                }
                <div style={{marginTop: '10px'}}>
                    <Alert message="注：若更换车型产生额外费用，需与用户线下沟通处理" type="warning"/>
                </div>
            </Form.Item>
            <Form.Item name={'veh_code'} label={'预定车辆'} rules={[{required: true, message: '请选择预定车辆'}]}>
                <Select
                    options={list}
                />
            </Form.Item>
        </>
    );
};

export default CarPlatoon;
